import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { t } from 'i18next';
import { Link } from 'react-router-dom';
import { DashboardContent } from '@/layouts/dashboard';
import { Widget, WidgetBody, WidgetCount, WidgetHeader, WidgetHeaderContent, WidgetTitle, WidgetWrapper } from '@/components/custom/widget';
import ChallengeTab from '../../ChallengeTab';
import StudentDataGrid from './StudentDataGrid';
import HitsByMatterColumnChart from './HitsByMatterColumnChart';
import BannerChallenge from './BannerChallenge';
import ProfileChallenge from './ProfileChallenge';

export default function ViewChallengeDefault({ selectedTab, uri, challengeId, challenge, challengeData, challengeParticipants, participants, filters, orderByAccuracy, setOrderByAccuracy, hasMore, setPageNumber }) {
  const breadcrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: uri,
        name: 'Desafio da Semana',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <ChallengeTab selectedTab={selectedTab} />

      <div className="filter-bar">
        <div className="filter-bar__inner">
          <Link
            className="filter-bar__back"
            to="/desafio-da-semana/resultados"
          >
            <span className="card__icon-wrapper card__icon-wrapper--sm">
              <FiChevronLeft className="card__icon" />
            </span>
            <span className="filter-bar__back-container">
              <span className="filter-bar__title">{challenge?.title}</span>
            </span>
          </Link>
        </div>
      </div>

      <BannerChallenge challenge={challenge} />

      <WidgetWrapper>
        <ProfileChallenge data={challenge} />

        <Widget style={{ flexGrow: 4 }}>
          <WidgetHeader>
            <WidgetTitle>Índice de acerto por matéria</WidgetTitle>
          </WidgetHeader>

          <WidgetBody>
            <HitsByMatterColumnChart chartData={challengeData} />
          </WidgetBody>
        </Widget>
      </WidgetWrapper>

      <Widget>
        <WidgetHeader>
          <WidgetHeaderContent>
            <WidgetTitle>Participantes</WidgetTitle>
            <WidgetCount>
              <span>Total de {challengeParticipants.length}</span>
            </WidgetCount>
          </WidgetHeaderContent>
        </WidgetHeader>

        <WidgetBody>
          <div className="filter-bar filter-bar--borderless">
            <div className="filter-bar__inner">
              <div className="filter-bar__row">
                <label
                  className="filter-bar__label"
                  htmlFor="search"
                >
                  {t('textsCommon.research')}
                </label>
                <input
                  className="form__control form__control--search-with-icon"
                  placeholder="Buscar por estudante"
                  type="search"
                  name="search"
                  id="search"
                  value={filters.values.searchTerm}
                  onChange={event => filters.setFieldValue('searchTerm', event.target.value)}
                  style={{ width: '400px' }}
                />
              </div>
            </div>
          </div>

          <StudentDataGrid
            setOrderByAccuracy={setOrderByAccuracy}
            orderByAccuracy={orderByAccuracy}
            hasMore={hasMore}
            setPageNumber={setPageNumber}
            participants={participants}
            challengeId={challengeId}
          />
        </WidgetBody>
      </Widget>
    </DashboardContent>
  );
}
